import { ReactNode, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';

interface ElementPortalProps {
    id?: string;
    data?: Record<string, unknown>;
    container?: HTMLElement | null;
    register?: (id: string, data: Record<string, unknown> | null) => void;
    unregister?: (id: string) => void;
    children?: ReactNode;
}

function ElementPortal({
    id = null,
    data = null,
    container = null,
    register = null,
    unregister = null,
    children = null,
}: ElementPortalProps) {
    const finalId = useMemo(() => id || `element-${new Date().getTime()}`, [id]);

    useEffect(() => {
        if (register !== null) {
            register(finalId, data);
        }
        return () => {
            if (unregister !== null) {
                unregister(finalId);
            }
        };
    }, [finalId, data, register, unregister]);

    return container !== null ? ReactDOM.createPortal(children, container) : null;
}

export default ElementPortal;
